angular.module('dialogs')
    .controller('PreDrawCertificateDialogCtrl',
        [
            '$scope', '$modalInstance', '$routeParams', 'EventFactory', 'appInfoFactory',
            function ($scope, $modalInstance, $routeParams, eventFactory, appInfoFactory) {

                function newPreDrawCertificate() {
                    $scope.PreDrawCertificate = {
                        AdjudicatorName: "",
                        InitialsForQ1: "",
                        InitialsForQ2: "",
                        InitialsForQ3: "",
                        InitialsForQ4: "",
                        InitialsForQ5: "",
                        InitialsForQ6: "AUTO",
                        InitialsForQ7: "",
                        Q8DrawFirst: "",
                        Q8DrawSecond: "",
                        Q8DrawThrird: "",
                        Q8DrawFourth: "",
                        Q8DrawFifth: "",
                        Q8DrawSixth: "",
                        Q8DrawBooster: "",
                        Q8DrawHour: "",
                        Q8DrawMinute: "",
                        Q8DrawSeconds: "",
                        InitialsForQ9: "",
                        Q10Comments: "",
                        SignedForDeloitte: "",
                        SignedForSis: "",
                        InitialsForQ3B: ""
                    }

                    appInfoFactory.getDateTime()
                        .success(function (dateTime) {
                            var today = new Date(JSON.parse(dateTime));
                            $scope.PreDrawCertificate.CertificationDate = today;
                        })
                        .error(function (error) {
                            $.message(error.ExceptionMessage, MessageType.Error);
                        });
                }

                function mapPreDrawCertificate(preDrawCertificate) {
                    $scope.PreDrawCertificate = {
                        AdjudicatorName: preDrawCertificate.AdjudicatorName,
                        CertificationDate: preDrawCertificate.CertificationDate,
                        InitialsForQ1: preDrawCertificate.InitialsForQ1,
                        InitialsForQ2: preDrawCertificate.InitialsForQ2,
                        InitialsForQ3: preDrawCertificate.InitialsForQ3,
                        InitialsForQ4: preDrawCertificate.InitialsForQ4,
                        InitialsForQ5: preDrawCertificate.InitialsForQ5,
                        InitialsForQ6: preDrawCertificate.InitialsForQ6,
                        InitialsForQ7: preDrawCertificate.InitialsForQ7,
                        Q8DrawFirst: preDrawCertificate.Q8DrawFirst,
                        Q8DrawSecond: preDrawCertificate.Q8DrawSecond,
                        Q8DrawThrird: preDrawCertificate.Q8DrawThrird,
                        Q8DrawFourth: preDrawCertificate.Q8DrawFourth,
                        Q8DrawFifth: preDrawCertificate.Q8DrawFifth,
                        Q8DrawSixth: preDrawCertificate.Q8DrawSixth,
                        Q8DrawBooster: preDrawCertificate.Q8DrawBooster,
                        Q8DrawHour: preDrawCertificate.Q8DrawHour,
                        Q8DrawMinute: ("0" + preDrawCertificate.Q8DrawMinute).slice(-2),
                        Q8DrawSeconds: ("0" + preDrawCertificate.Q8DrawSeconds).slice(-2),
                        InitialsForQ9: preDrawCertificate.InitialsForQ9,
                        Q10Comments: preDrawCertificate.Q10Comments,
                        SignedForDeloitte: preDrawCertificate.SignedForDeloitte,
                        SignedForSis: preDrawCertificate.SignedForSis,
                        InitialsForQ3B: preDrawCertificate.InitialsForQ3B
                    }
                }

                function getPreDrawCertificate() {
                    eventFactory.GetPreDrawCertificate($routeParams.eventId)
                        .success(function (preDrawCertificate) {
                            if (preDrawCertificate === "null")
                                newPreDrawCertificate();
                            else
                                mapPreDrawCertificate(preDrawCertificate);
                        })
                        .error(function (error) { $.message(error.ExceptionMessage, MessageType.Error); });
                }

                function init() {
                    getPreDrawCertificate();
                }

                init();

                $scope.no = function () {
                    $modalInstance.dismiss('no');
                };

                $scope.setFormScope = function (scope) {
                    this.formScope = scope;
                }

                $scope.SavePreDrawCertificate = function () {
                    eventFactory.SavePreDrawCertificate($routeParams.eventId, $scope.PreDrawCertificate)
                        .success(function (event) {
                            $modalInstance.dismiss('no');
                            $.message(MessageText.EventPreDrawCertificateSaved, MessageType.Success);
                        })
                        .error(function (error) {
                            if (error.ModelState) $.message(JSON.stringify(error.ModelState), MessageType.Error);
                            else $.message(error.ExceptionMessage, MessageType.Error);
                        });
                }
            }
        ]);